module.exports = __webpack_public_path__ + "img/back.c460fe33.svg";